/* eslint-disable react-hooks/exhaustive-deps */

import React, {cloneElement, useEffect, useMemo, useState} from 'react';
import {
    ADD_TAGS_TO_CONTACTS,
    DELETE_CONTACTS,
    GET_CONTACTS,
    GET_CONTACTS_EXPORT,
    MERGE_CONTACTS,
    REMOVE_TAGS_FROM_CONTACTS
} from "../../database/queries/contactQueries";
import {SizeMe} from "react-sizeme";
import {isEqual} from "lodash";
import {makeStyles} from "@material-ui/core/styles";
import {notify} from "../../utils/notify";
import {useMutation, useQuery} from "@apollo/react-hooks";
import PageBar from "../Common/PageBar";
import {Link, Route, Switch, useHistory, useRouteMatch} from "react-router-dom";
import usePersistentStore from "../../persistentStore";
import {GET_FILTER} from "../../database/queries/filterQueries";
import {ADD_CONTACTS_TO_CONTACT_LISTS} from "../../database/queries/contactListQueries";
import * as utils from "../../utils/utils";
import {sortedArraysEqual} from "../../utils/utils";
import moment from "moment";
import ExpandedTable from "../Common/ExpandedTable/expandedTable";
import CssBaseline from "@material-ui/core/CssBaseline";
import HtmlTooltip from "../Common/htmlTooltip";
import Moment from "react-moment";
import CalendarStrings from "../../constants/calendarStrings";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        marginTop: 20,
    },
}));

const ContactList = props => {
    const classes = useStyles();
    const [searchStr, setSearchStr] = useState('');
    const [filter, setFilter] = useState();
    const [exportContactIds, setExportContactIds] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [exportFields, setExportFields] = useState([]);
    const [selectedObj, setSelectedObj] = useState({});
    const [globalPersistentState, globalPersistentActions] = usePersistentStore();
    const [contacts, setContacts] = useState([]);
    const [contactCount, setContactCount] = useState(0);
    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [orderList, setOrderList] = useState();
    const [skipPageReset, setSkipPageReset] = useState(false)
    const history = useHistory();
    let {url} = useRouteMatch();

    const filterAndSortCurrentAccounts = (contactAccountPositions) => {
        if (!contactAccountPositions || contactAccountPositions.length === 0) return [];
        let currentAccountPositions = contactAccountPositions.filter((obj) => obj.current === true);
        currentAccountPositions.sort(function (a, b) {
            return a.startDate - b.startDate;
        });
        return currentAccountPositions;
    }

    const columns = useMemo(
        () => [
            {
                id: 'displayName',
                Header: 'Name',
                accessor: r => {
                    return (
                        <Link to={`${url}/${r.contactId}`}
                              onClick={() => globalPersistentActions.setDetailTabsTitle(r.displayName)}>
                            {r.contactLastFirstName}
                        </Link>
                    );
                },
                sortFields: ['contactLastName', 'contactFirstName']
            },
            {
                id: 'contactLinkedinId',
                Header: 'Linkedin Id',
                accessor: r => {
                    if (r.contactLinkedinId) {
                        return <a href={'https://linkedin.com/in/' + r.contactLinkedinId}
                                  target={"_blank"} rel="noopener noreferrer">{r.contactLinkedinId}</a>
                    } else {
                        return ""
                    }
                },
                sortFields: ['contactLinkedinId']
            },
            {
                id: 'accounts',
                Header: 'Accounts',
                accessor: r => {
                    const currentAccounts = filterAndSortCurrentAccounts(r.contactAccountPositions);
                    if (currentAccounts.length === 0) return "";

                    let content = '<table>';
                    for (let a = 0; a < currentAccounts.length; a++) {
                        const acct = currentAccounts[a];
                        if (acct.account) {
                            content += '<tr>';
                            content += `<td style="border: 1px dotted #999999; padding: 3px;">${acct.account.accountName}</td>`;
                            content += `<td style="border: 1px dotted #999999; padding: 3px;">${acct.title}</td>`;
                            content += '</tr>';
                        }
                    }
                    content += '</table>';

                    return <HtmlTooltip
                        title={currentAccounts[0].account ? currentAccounts[0].account.accountName : ''}>
                        {content}
                    </HtmlTooltip>;
                },
                disableSortBy: true,
            },
            {
                id: 'updatedAt',
                Header: 'Last Updated',
                accessor: r => <Moment calendar={CalendarStrings}>{r.updatedAt}</Moment>,
                sortFields: ['updatedAt']
            },
            {
                id: 'tags',
                Header: 'Tags',
                accessor: r => {
                    return <span>{r.tags.map(tag => tag.tag).join(', ')}</span>
                },
                disableSortBy: true,
            }
        ],
        []
    )

    const {loading: getContactsLoading, error: getContactsError, data: getContactsData, refetch: getContactsRefetch} =
        useQuery(GET_CONTACTS, {
            fetchPolicy: "no-cache",
            variables: {
                searchStr: searchStr,
                filterSQL: filter ? filter.filterSQL : null,
                limit: pageSize,
                offset: pageIndex * pageSize,
                orderList: orderList
            },
        });

    const {refetch: getContactsExportRefetch} = useQuery(GET_CONTACTS_EXPORT, {
        skip: exportContactIds.length === 0,
        variables: {
            contactIds: exportContactIds
        }
    });

    const {data: getFilterData, refetch: getFilterRefetch} = useQuery(GET_FILTER, {
        skip: !globalPersistentState.contactFilterId,
        variables: {
            filterId: globalPersistentState.contactFilterId,
        },
    });

    const [deleteContacts, {error: deleteContactsError}] = useMutation(DELETE_CONTACTS);
    const [mergeContacts, {error: mergeContactsError}] = useMutation(MERGE_CONTACTS);
    const [addTagsToContacts] = useMutation(ADD_TAGS_TO_CONTACTS);
    const [addContactsToContactLists] = useMutation(ADD_CONTACTS_TO_CONTACT_LISTS);
    const [removeTagsFromContacts] = useMutation(REMOVE_TAGS_FROM_CONTACTS);

    const handleSearch = (s) => {
        setSearchStr(s);
        getContactsRefetch();
    };

    const handleRefresh = () => {
        console.log('setSkipPageReset false due to refresh');
        setSkipPageReset(false);
        getContactsRefetch().then((result) => {
            if (!skipPageReset) setSkipPageReset(true);
        });
    };

    const handleDelete = async () => {
        deleteContacts({
            variables: {deleteContactIds: selectedIds}
        }).then(async deleteContactsResult => {
            console.log('setSkipPageReset false due to delete');
            setSkipPageReset(false);
            await getContactsRefetch();
            return deleteContactsResult;
        }).then(async deleteContactsResult => {
            if (deleteContactsResult.data.deleteContacts.returnCode === 0) {
                notify('deleteContacts', 'info', deleteContactsResult.data.deleteContacts.message);
            } else {
                notify('deleteContacts', 'error', deleteContactsResult.data.deleteContacts.message);
            }
        }).catch(e => {
            notify('deleteContacts', 'error', e.message);
            getContactsRefetch();
        })
    };

    const handleAddTags = async (tagObjList) => {
        addTagsToContacts({
            variables: {contactIdList: selectedIds, tagObjList: tagObjList}
        }).then(async addTagsToContactsResult => {
            await getContactsRefetch();
            return addTagsToContactsResult;
        }).then(async addTagsToContactsResult => {
            notify('addTagsToContacts', addTagsToContactsResult.data.addTagsToContacts.returnCode === 0 ? 'info' : 'error', addTagsToContactsResult.data.addTagsToContacts.message);
        }).catch(e => {
            notify('addTagsToContacts', 'error', e.message);
            getContactsRefetch();
        });
    };

    const handleRemoveTags = async (tagObjList) => {
        removeTagsFromContacts({
            variables: {contactIdList: selectedIds, tagObjList: tagObjList}
        }).then(async removeTagsFromContactsResult => {
            await getContactsRefetch();
            return removeTagsFromContactsResult;
        }).then(async removeTagsFromContactsResult => {
            notify('removeTagsFromContacts',
                removeTagsFromContactsResult.data.removeTagsFromContacts.returnCode === 0 ? 'info' : 'error',
                removeTagsFromContactsResult.data.removeTagsFromContacts.message);
        }).catch(e => {
            getContactsRefetch();
            notify('removeTagsFromContacts', 'error', e.message);
        });
    };

    const handleAddToContactLists = (selectedContactListRows) => {
        const selectedContactListIds = selectedContactListRows.map(row => row.contactListId);

        addContactsToContactLists({
            variables: {contactIdList: selectedIds, contactListIdList: selectedContactListIds}
        }).then(addContactsToContactListsResult => {
            notify('addContactsToContactLists', addContactsToContactListsResult.data.addContactsToContactLists.returnCode === 0 ? 'info' : 'error', addContactsToContactListsResult.data.addContactsToContactLists.message);
            getContactsRefetch();
            // tableRef.current && tableRef.current.onQueryChange();
        }).catch(e => {
            notify('addContactsToContactLists', 'error', e.message);
            getContactsRefetch();
            // tableRef.current && tableRef.current.onQueryChange();
        });
    };

    const handleFilterApply = (filterId) => {
        globalPersistentActions.setContactFilterId(filterId);
        if (!filterId) setFilter();
    };

    const handleImport = () => {
        console.log('import');
    };

    // const result = useMemo(() => contacts, [contacts]);

    const handleMerge = (mainContactId) => {
        mergeContacts({
            variables: {mainContactId: mainContactId, mergeContactIds: selectedIds}
        }).then(mergeContactsResult => {
            if (mergeContactsResult.data.mergeContacts.returnCode === 0) {
                notify('mergeContacts', 'info', mergeContactsResult.data.mergeContacts.message);
                getContactsRefetch();
                // tableRef.current && tableRef.current.onQueryChange();
            } else {
                notify('mergeContacts', 'error', mergeContactsResult.data.mergeContacts.message);
                getContactsRefetch();
                // tableRef.current && tableRef.current.onQueryChange();
            }
        }).catch(e => {
            notify('mergeContacts', 'error', e.message);
            getContactsRefetch();
            // tableRef.current && tableRef.current.onQueryChange();
        })
    };

    useEffect(() => {
        console.log('getContactsData', getContactsData);
        if (getContactsData) {
            globalPersistentActions.setDetailTabsTitle();
            setContacts(getContactsData.contacts.rows);
            setContactCount(getContactsData.contacts.count);
        }
    }, [getContactsData]);

    useEffect(() => {
        if (selectedIds.length > 0) setExportContactIds(selectedIds);
    }, [exportFields]);

    const handleExport = (fields) => {
        setExportFields(fields);
    };

    useEffect(() => {
        if (exportContactIds.length > 0) {
            getContactsExportRefetch().then(async fetchResult => {
                const rows = await utils.convertExportsToCSV(fetchResult.data.contactsExport, exportFields);
                const element = document.createElement("a");
                const file = new Blob([rows],
                    {type: 'text/csv;charset=utf-8'});
                element.href = URL.createObjectURL(file);
                element.download = 'junctionbox-export-' + moment().format() + '.csv';
                document.body.appendChild(element);
                element.click();
            }).catch(e => {
                console.trace(e);
            });
        }
    }, [exportContactIds]);

    useEffect(() => {
        if (deleteContactsError) notify('deleteContactError', 'error', deleteContactsError.message);
        if (mergeContactsError) notify('mergeContactError', 'error', mergeContactsError.message);
        if (getContactsError) notify('getContactsError', 'error', getContactsError.message);
    }, [deleteContactsError, getContactsError, mergeContactsError]);

    useEffect(() => {
        getContactsRefetch();
        // tableRef.current && tableRef.current.onQueryChange();
    }, [filter]);

    useEffect(() => {
        if (getFilterData && getFilterData.filter) {
            setFilter(getFilterData.filter);
        }
    }, [getFilterData]);

    useEffect(() => {
        if (globalPersistentState.filterId) getFilterRefetch();
    }, [globalPersistentState.filterId]);

    const getOrderList = (sortBy) => {
        let orderList = [];
        if (sortBy && sortBy.length > 0) {
            for (let s = 0; s < sortBy.length; s++) {
                const sortFld = sortBy[s];
                const sortDir = sortFld.desc ? 'DESC' : 'ASC';
                const sortCol = columns.filter(column => column.id === sortFld.id);
                if (sortCol && sortCol.length > 0) {
                    const sortFields = sortCol[0].sortFields;
                    if (sortFields) {
                        for (let f = 0; f < sortFields.length; f++) {
                            orderList.push(`${sortFields[f]} ${sortDir}`);
                        }
                    }
                }
            }
        }
        console.log('orderList', orderList);
        return orderList;
    }

    const getData = (newPageIndex, newPageSize, newSortBy) => {
        const newOrderList = getOrderList(newSortBy);
        if (!isEqual(orderList, newOrderList)) setOrderList(newOrderList);
        if (newPageSize !== pageSize) setPageSize(newPageSize);
        if (newPageIndex !== pageIndex) setPageIndex(newPageIndex);
        getContactsRefetch();
    }

    // const contactData = React.useMemo(() => contacts, [contacts])

    return (
        <Switch>
            <Route exact path={`${url}`}>
                <PageBar
                    {...props}
                    title={`Contacts (${selectedIds.length}/${contactCount})`}
                    handleSearch={handleSearch}
                    handleRefresh={handleRefresh}

                    handleAdd={() => {
                        console.log('## SVR contactList ## changing history', `${url}/new`);
                        history.push(`${url}/new`);
                    }}
                    addDisabled={selectedIds.length > 0}

                    mergeType={"contact"}
                    mergeChoices={selectedRows}
                    handleMerge={handleMerge}
                    mergeDisabled={selectedIds.length < 2}

                    handleEdit={() => {
                        console.log('## SVR contactList ## changing history', selectedObj, `${url}/${selectedObj.contactId}`);
                        history.push(`${url}/${selectedObj.contactId}`);
                    }}
                    editDisabled={selectedIds.length !== 1}

                    addTagsTitle={"Change Tags for Selected Contacts"}
                    handleAddTags={handleAddTags}
                    handleRemoveTags={handleRemoveTags}
                    tagDisabled={selectedIds.length === 0}

                    addToContactListsDisabled={selectedIds.length === 0}
                    handleAddToContactLists={handleAddToContactLists}

                    filterType="contact"
                    filterName={filter ? filter.filterName : null}
                    handleFilterApply={handleFilterApply}

                    handleDelete={handleDelete}
                    deleteDisabled={selectedIds.length === 0}

                    handleImport={handleImport}

                    handleExport={handleExport}
                    exportDisabled={selectedIds.length === 0}

                    showLoading={getContactsLoading}
                >
                </PageBar>
                <div className={classes.root}>
                    <SizeMe>
                        {({size}) => {
                            let height = size.height;
                            if (!height) height = window.innerHeight;

                            return (
                                <div>
                                    <CssBaseline/>
                                    {contacts && (<ExpandedTable
                                        columns={columns}
                                        data={contacts}
                                        dataCount={contactCount}
                                        getData={getData}
                                        pageSize={pageSize}
                                        pageIndex={pageIndex}
                                        skipPageReset={skipPageReset}
                                        setSkipPageReset={setSkipPageReset}
                                        getRowId={row => row.contactId}
                                        testFieldName={"contactFirstName"}
                                        setSelected={(sortedIds, rows) => {
                                            const theSame = sortedArraysEqual(selectedIds, sortedIds);
                                            if (!theSame) {
                                                console.log('setting selected rows', sortedIds);
                                                setSelectedIds(sortedIds)
                                                setSelectedRows(rows);
                                                if (rows && rows.length === 1) {
                                                    setSelectedObj(rows[0])
                                                } else {
                                                    setSelectedObj({})
                                                }
                                            }
                                        }}
                                    />)}
                                </div>
                            );
                        }}
                    </SizeMe>
                </div>
            </Route>}
            <Route path={`${url}/:editId`}>
                {cloneElement(props.parent.routes.edit.component, {
                    ...props,
                    editType: 'contact',
                    parentRefresh: () => {
                        // tableRef.current && tableRef.current.onQueryChange();
                        getContactsRefetch();
                    },
                    parent: props.parent.routes.edit
                })}
            </Route>
        </Switch>
    );
};

export default ContactList;
